import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    Name: { label: i18n.t('app.name'), value: '' },
    TaxType: { label: i18n.t('impuestos.TaxType'), value: '' },
    TaxRate: { label: i18n.t('impuestos.TaxRate'), value: '', type: 'number' },
    TaxCategory: { label: i18n.t('impuestos.TaxCategory'), value: '' }
  } 
}
const getColumns = function getColumns () {
  return [
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'TaxType', title: i18n.t('impuestos.TaxType'), format: 'TIPOS_CODIGO_IMPUESTO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'TaxRate', title: i18n.t('impuestos.TaxRate'), columnMenu: 'myTemplate', width: '165px', locked: false },
    { field: 'TaxCategory', title: i18n.t('impuestos.TaxCategory'), format: 'TIPOS_CATEGORIA_IMPUESTOS', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'idImpuesto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
